import { ResponsiveLine } from '@nivo/line';

const data = [
    {
        id: 'dotted-line',
        data: [
            { x: 'Jan', y: 15 },
            { x: 'Feb', y: 5 },
            { x: 'Mar', y: 55 },
            { x: 'Apr', y: 25 },
        ],
    },
];

const MyDottedLineChart2 = () => (
    <ResponsiveLine
        data={data}
        margin={{ top: 50, right: 110, bottom: 50, left: 60 }}
        xScale={{ type: 'point' }}
        yScale={{ type: 'linear', min: 0, max: 'auto', stacked: false, reverse: false }}
        axisLeft={{ legend: 'Value', legendOffset: -40, legendPosition: 'middle' }}
        axisBottom={{ legend: 'Month', legendOffset: 36, legendPosition: 'middle' }}
        colors={{ scheme: 'category10' }}
        lineWidth={2}
        pointSize={10}
        pointColor={{ theme: 'background' }}
        pointBorderWidth={2}
        pointBorderColor={{ from: 'serieColor' }}
        useMesh={true}
        enablePoints={true}
        enableGridX={false}
        enableGridY={false}
        
        // Define the dotted line pattern
        defs={[
            {
                id: 'dottedPattern',
                type: 'patternLines',
                background: 'transparent',
                color: 'inherit', // Use the line color
                rotation: 0,
                lineWidth: 2,
                spacing: 6, // Controls the distance between dots
            },
        ]}
        fill={[{ match: '*', id: 'dottedPattern' }]} // Apply the pattern
    />
);

export default MyDottedLineChart2;
